// project import
import { SectionStatus } from 'types';
import getApplicationsMenu from './applications';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

export const generateMenuItems = (role: string, deliverySectionStatus: SectionStatus, analyticsSectionStatus: SectionStatus): { items: NavItemType[] } => {
  return {
    items: [getApplicationsMenu(role, deliverySectionStatus, analyticsSectionStatus)],
  };

};
